<div class="relative">
    <label for="values-{filterObject.id}">Werte</label>
    <input type="text" id="values-{filterObject.id}"
           class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none {invalid ? 'bg-red-50 border-red-500' : '' }" placeholder="Wert eingeben"
           value="{value}"
           on:input={(e) => searchForValue(e.target.value, false) }>

    {#if inputIsFocused}
        <ul class="border border-gray-200 bg-white rounded shadow absolute z-50 w-full px-2 max-h-[50vh] overflow-auto">
            {#if valuesLoading}
                <li class="py-2 cursor-pointer border-b border-gray-200 text-center">
                    <span class="align-middle lds-dual-ring"></span>
                </li>
            {:else}
                {#each items as item}
                    <li class="border-b border-gray-200 last:border-0">
                        <a href={void(0)} class="block py-2 cursor-pointer hover:bg-gray-50" on:click={() => {setValue(filterObject, item)}}>
                            {item.name}
                            {#if filterObject.resource.joinBy !== 'generic_import_external_id' && item.hasOwnProperty('valid_from_date') && item.hasOwnProperty('valid_to_date')}
                                <span class="inline-block mt-1 italic text-sm text-gray-700">{formatDate(item.valid_from_date)} - {formatDate(item.valid_to_date)}</span>
                            {/if}
                            {#if filterObject.getFilterEndpoint() === "events" || filterObject.getFilterEndpoint() === "public_transport_lines"}
                                <br>
                                <span class="inline-block mt-1 italic text-sm text-gray-700">{ getDescriptionData(item) }</span>
                            {/if}
                        </a>
                    </li>
                {/each}
            {/if}
        </ul>
    {/if}

    {#if valuesList.length}
        <ul class="mt-2">
            {#each valuesList as val}
                <li class="bg-green-drkn text-white p-0.5 border-b border-white flex justify-between px-2">
                    {val.name}
                    <button class="h-0" on:click={() => removeValue(filterObject, val)}>&times;</button>
                </li>
            {/each}
        </ul>
    {/if}
</div>

<script>
    import {createEventDispatcher, onMount} from 'svelte';

    const dispatch = createEventDispatcher();

    export let filterObject;

    export let valueFromUrl = "";

    export let config;

    let inputIsFocused = false

    let timeout;

    let items = [];

    let value = "";

    let valuesList = [];

    let valuesLoading = false;

    let invalid = true;

    let sort;

    onMount(() => {
        const filterValue = valueFromUrl || filterObject.getValue();
        if (filterValue) {
            filterValue.split(",").forEach(val => {
                searchForValue(val, true, true);

            });
        }
    });

    function searchForValue(value, byId = false, isFromUrl = false) {
        if (!byId) {
            clearTimeout(timeout);
        }
        inputIsFocused = false;
        timeout = setTimeout(async () => {
            if (!byId && value.length < 2) return;
            valuesLoading = true;
            inputIsFocused = true;
            items = await getDataportalEntities(filterObject.getFilterEndpoint(), value, byId, isFromUrl) || [];
            valuesLoading = false;
        }, 500);
    }

    async function getDataportalEntities(endpoint, value, byId, isFromUrl = false) {
        let filterName = `${endpoint}.${byId ? 'id' : 'name'}`;
        if (filterObject.resource.dataportalFilterName && isFromUrl) {
            filterName = filterObject.resource.dataportalFilterName;
            if (filterObject.resource.name === 'public_transport_line_geofence_external_id') {
                value = await getTransportLineByExternalId(endpoint, value);
            }
        }
        sort = (endpoint === 'public_transport_stops') ? '&sort=-public_transport_lines_count' : '';
        const url = `${config.dpmsEndpoint}${endpoint}?filter[${filterName}]=${value}&page[size]=100${sort}`;
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const item = await response.json();
        if (byId) {
            return setValue(filterObject, item.data[0]);
        }
        return item.data;
    }

    async function getTransportLineByExternalId(endpoint, value) {
        const url = `${config.dpmsEndpoint}${endpoint}?filter[import_external_id_begins_with]=${value}&page[size]=100${sort}`;
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const item = await response.json();
        return item.data[0].id;

    }

    function setValue(filterObject, item) {
        const filterInput = document.querySelector(`#values-${filterObject.id}`);
        if (filterInput) {
            filterInput.value = "";
        }

        // return if item already selected
        if (valuesList.some(value => value.id === item.id)) return;

        valuesList = [...valuesList, item];

        inputIsFocused = false;

        dispatchUpdate(filterObject, valuesList);
    }

    function formatDate(isoDate) {
        const date = new Date(isoDate); // Konvertierung in ein Date-Objekt
        const day = date.getDate().toString().padStart(2, "0"); // Tag (mit führender Null)
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Monat (mit führender Null)
        const year = date.getFullYear(); // Jahr
        return `${day}.${month}.${year}`; // Deutsche Datum im Format "dd.mm.yyyy"
    }

    function getDescriptionData(item) {
        if (item.hasOwnProperty('start_datetime') && item.hasOwnProperty('end_datetime') && item.hasOwnProperty('poi')) {
            return `(${formatDate(item.start_datetime)} - ${formatDate(item.end_datetime)}), ${item.poi.name}`;
        }
        if (item.hasOwnProperty('description') && item.description !== null) {
            return item.description
        }
        return "";
    }

    function removeValue(filterObject, val) {
        valuesList = valuesList.filter(value => {
            return value !== val;
        });
        dispatchUpdate(filterObject, valuesList)
    }

    function dispatchUpdate(filterObject, values) {
        let joinBy = filterObject.resource.joinBy ? filterObject.resource.joinBy : 'id';
        invalid = valuesList.length === 0;
        dispatch("updateFilter", {
            filterObject,
            type: "values",
            value: values.map(value => value[joinBy]).join(",")
        });
    }

    document.addEventListener('click', () => {
        inputIsFocused = false
    });

</script>

<style>
    .lds-dual-ring {
        display: inline-block;
    }

    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid #111;
        border-color: #111 transparent #111 transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }

    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>